import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import Button from "../ui/Button";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import FormFieldsContainer from "../ui/FormFieldsContainer";
import Textarea from "../ui/Textarea";

export interface RejectFormBody {
  text: string;
}

type RejectFormProps = {
  onSubmit: (form: RejectFormBody) => Promise<void>;
  onClose: () => void;
  isDisabled: boolean;
};

const RejectForm: FC<RejectFormProps> = ({ onSubmit, onClose, isDisabled }: RejectFormProps) => {
  const i18n = useI18n();

  return (
    <Form<RejectFormBody>
      submitText={i18n.t.common.send}
      onSubmit={() => onSubmit}
      disabled={isDisabled}
      secondaryButton={
        <Button
          type="secondary"
          buttonProps={{
            onClick: () => onClose(),
          }}
        >
          {i18n.t.common.cancel}
        </Button>
      }
    >
      {({ register, formState: { errors } }) => {
        return (
          <FormFieldsContainer>
            <label>{i18n.t.common.rejectImagesForm}</label>
            <FormField error={errors.text}>
              {({ labelId, isInvalid, isOptional }) => (
                <Textarea
                  id={labelId}
                  isInvalid={isInvalid}
                  {...register("text", {
                    required: !isOptional,
                    minLength: 1,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default RejectForm;
